import axios from "axios";
import { store } from "redux/store";

import { IGmuTokenRequest, IGmuTokenResponse } from "models/Gmu/gmuToken.model";
import { ITokenModel } from "models/Login/token.model";

export const getGmu = async (
  token: ITokenModel,
  merchantNo: string
): Promise<IGmuTokenResponse> => {
  const paramsGmu: IGmuTokenRequest = {
    MerchantNo: merchantNo,
    TokenSessionId: token.TokenSessionId,
  };

  const reduxStore = store.getState();
  const userIndividual = reduxStore.login.user?.mbb_phoneNumber;
  const userCorpatare = reduxStore.login.user?.mbb_userCode;
  paramsGmu.UserId =
    reduxStore.login.user?.corporateOrIndividual === "2"
      ? userIndividual
      : userCorpatare;
  paramsGmu.SecurityKey = token.access_token;

  const reqData = serviceGmuYokenModelCreator(paramsGmu);

  try {
    const { data } = await axios.post<IGmuTokenResponse>(
      "/api/Entrypoint",
      reqData,
      {
        headers: {
          Authorization: `Bearer ${token.access_token}`,
        },
      }
    );

    if (
      data.DialogBoxes.length > 0 ||
      (data.ReturnCode !== null && data.ReturnCode != 0)
    ) {
      let mssgg =
        data.DialogBoxes.length > 0
          ? data.DialogBoxes[0].Message
          : "Şu anda size hizmet veremiyoruz. Lütfen daha sonra tekrar deneyiniz.";
      return mssgg;
    }

    return data;
  } catch (error: any) {
    console.log(`GMU_SERVICE_ERROR => `, error);
    return error;
  }
};

const serviceGmuYokenModelCreator = (gmuParams: IGmuTokenRequest) => {
  let req = {
    UserId: gmuParams.UserId,
    SecurityKey: gmuParams.SecurityKey,
    MerchantNo: gmuParams.MerchantNo,
    TokenSessionId: gmuParams.TokenSessionId,
    NextTransactionUrl: "MPSGmuBackofficeUrl/BackofficeUrl",
  };

  return req;
};
